module.exports = "/images/icon_07.png?32338ec5c71643bf6095cf5a7af0ff03";